import React from 'react';
import styled from 'styled-components';
import Recaptcha from '../../../commons/component/captcha/recaptcha';
import Error from '../../../commons/component/error';
import Input from '../../../commons/component/input';
import InputNumber from '../../../commons/component/input-number';
import config from '../../../generated/config';
import {
  hasError,
  updateCnpj,
  getCompanyFormStatus,
  checkCnpjField,
  checkCompanyName,
  checkEmailField
} from '../../cadastro-services';

const FirstStepComponent = ({
  cadastroState,
  updateState,
  setCaptcha,
  cnpjRef,
  corporateNameRef,
  fantasyNameRef,
  emailRef
}) => {
  const { errors } = cadastroState;
  return (
    <FirstStepWrapper>
      <div className="inputGroup --marginBottomMd" id="cnpj">
        <label className="inputGroup-label --acronym" htmlFor="cnpj-input">
          <span className="required-asterisk">*</span> cnpj
        </label>
        <div className="addonWrapper">
          <InputNumber
            name="cnpj"
            id="cnpj-input"
            data-page="signup"
            data-form="signup"
            onChange={e => {
              updateCnpj(e, cadastroState, updateState);
            }}
            onBlur={e => checkCnpjField(e.target.value, cadastroState, updateState)}
            value={cadastroState.company.cnpj}
            className={`inputGroup-input --withAddOn ${hasError('cnpj', errors)}`}
            type="tel"
            mask="__.___.___/____-__"
            placeholder="Ex: 12.345.678/1234-56"
            inputRef={cnpjRef}
            required
          />
        </div>
        <Error errors={errors} name="cnpj" />
      </div>

      {config.enableCaptchaOnPJRegister && <Recaptcha ref={ref => setCaptcha(ref)} />}

      <div className="inputGroup" id="corporateName">
        <label className="inputGroup-label" htmlFor="corporateName-input">
          <span className="required-asterisk">*</span> razão social
        </label>
        <Input
          name="corporateName"
          id="corporateName-input"
          onChange={e => {
            updateState({
              ...cadastroState,
              company: {
                ...cadastroState.company,
                corporateName: e.target.value
              },
              companyFormStatus: getCompanyFormStatus(cadastroState)
            });
          }}
          onBlur={e =>
            checkCompanyName(e.target.value, 'corporateName', cadastroState, updateState)
          }
          value={cadastroState.company.corporateName}
          data-page="signup"
          data-form="signup"
          className={`inputGroup-input --large ${hasError('corporateName', errors)}`}
          type="text"
          inputRef={corporateNameRef}
          required
        />
        <Error errors={errors} name="corporateName" />
      </div>

      <div className="inputGroup" id="fantasyName">
        <label className="inputGroup-label" htmlFor="fantasyName-input">
          <span className="required-asterisk">*</span> nome fantasia
        </label>
        <Input
          name="fantasyName"
          id="fantasyName-input"
          onChange={e => {
            updateState({
              ...cadastroState,
              company: {
                ...cadastroState.company,
                fantasyName: e.target.value
              },
              companyFormStatus: getCompanyFormStatus(cadastroState)
            });
          }}
          onBlur={e => checkCompanyName(e.target.value, 'fantasyName', cadastroState, updateState)}
          value={cadastroState.company.fantasyName}
          data-page="signup"
          data-form="signup"
          className={`inputGroup-input --large ${hasError('fantasyName', errors)}`}
          type="text"
          inputRef={fantasyNameRef}
          required
        />
        <Error errors={errors} name="fantasyName" />
      </div>

      <div className="inputGroup" id="email">
        <label className="inputGroup-label" htmlFor="email-input">
          <span className="required-asterisk">*</span> e-mail de faturamento para envio da NF
        </label>
        <Input
          placeholder="Ex. joaodasilva@gmail.com"
          className={`inputGroup-input ${hasError('email', errors)}`}
          data-page="signup"
          data-form="signup"
          name="email"
          onChange={e => {
            updateState({
              ...cadastroState,
              company: {
                ...cadastroState.company,
                billing: {
                  ...cadastroState.company.billing,
                  billingEmail: e.target.value
                }
              },
              companyFormStatus: getCompanyFormStatus(cadastroState)
            });
          }}
          onBlur={e => checkEmailField(e.target.value, cadastroState, updateState)}
          value={cadastroState.company.billing.billingEmail}
          id="email-input"
          type="email"
          inputRef={emailRef}
          required
        />
        <Error errors={errors} name="email" />
      </div>
    </FirstStepWrapper>
  );
};

const FirstStepWrapper = styled.div``;

export default FirstStepComponent;
